import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mobile-not-supported',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-not-supported.component.html',
  styleUrls: ['./mobile-not-supported.component.css']
})
export class MobileNotSupportedComponent {}
